import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import MenuOutlined from '@material-ui/icons/MenuOutlined';
import ExpandMoreOutlined from '@material-ui/icons/ExpandMoreOutlined';
import ChevronRightOutlined from '@material-ui/icons/ChevronRightOutlined';
import ExitToAppOutlined from '@material-ui/icons/ExitToAppOutlined';

import AceLogo from '../../components/AceLogo/AceLogo';
import NavIcon from '../../components/ui/NavIcon';
import { logoutRequest } from '../../actions';
import { APP_SIDEBAR_NAV_GROUPS, pathMatchesNavLink, isGroupNavActive } from '../../constants/appNav';

const Sidebar = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const [openGroups, setOpenGroups] = useState({});

  const onLogoutClick = () => {
    dispatch(logoutRequest());
    history.push('/sign-in');
  };

  useEffect(() => {
    document.documentElement.style.setProperty('--app-shell-offset', expanded ? '244px' : '92px');
    return () => {
      document.documentElement.style.setProperty('--app-shell-offset', '92px');
    };
  }, [expanded]);

  useEffect(() => {
    const state = {};
    APP_SIDEBAR_NAV_GROUPS.forEach((g) => {
      state[g.id] = isGroupNavActive(location.pathname, g);
    });
    setOpenGroups(state);
  }, [location.pathname]);

  const toggleGroup = (id) => {
    if (!expanded) return;
    setOpenGroups((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className={`sidebar sidebar--modern ${expanded ? 'sidebar--expanded' : 'sidebar--collapsed'}`}>
      <div className='brand-logo'>
        <button
          type='button'
          className='sidebar__toggle'
          title={expanded ? 'Collapse sidebar' : 'Expand sidebar'}
          onClick={() => setExpanded((v) => !v)}
        >
          <MenuOutlined fontSize='small' />
        </button>
        <a href='/' className='sidebar__brand-anchor'>
          <AceLogo width={46} />
        </a>
      </div>
      <div className='menu'>
        {APP_SIDEBAR_NAV_GROUPS.map((group) => (
          <div className='sidebar__group' key={group.id}>
            <button type='button' className='sidebar__group-trigger' onClick={() => toggleGroup(group.id)}>
              <span className='sidebar__group-title'>{group.title}</span>
              {expanded ? (
                openGroups[group.id] ? (
                  <ExpandMoreOutlined fontSize='small' />
                ) : (
                  <ChevronRightOutlined fontSize='small' />
                )
              ) : null}
            </button>
            <ul style={{ display: !expanded || openGroups[group.id] ? 'block' : 'none' }}>
              {group.links.map((link) => (
                <li key={link.to}>
                  <NavLink
                    to={link.to}
                    exact={!!link.exact}
                    activeClassName='active'
                    title={link.title}
                    data-tour={
                      link.to === '/create-job'
                        ? 'nav-new-job'
                        : link.to === '/jobs'
                          ? 'nav-all-jobs'
                          : undefined
                    }
                  >
                    <span>
                      <NavIcon icon={link.icon} />
                    </span>
                    <span className='sidebar__label'>{link.title}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <ul>
          <li className='logout'>
            <button type='button' onClick={onLogoutClick} className='sidebar__logout-btn' title='Sign out'>
              <span>
                <ExitToAppOutlined fontSize='small' />
              </span>
              <span className='sidebar__label'>Sign out</span>
            </button>
          </li>
        </ul>
        <p className='copyright'>
          &#169; <a href='/'>Ace@2022</a>
        </p>
      </div>
    </div>
  );
};

export default Sidebar;
